import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";

export const defaultNS = "translation" as const;
export const resources = {
  en: {
    translation: en,
  },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ns: defaultNS,
    defaultNS: defaultNS,
    lng: "en",
    fallbackLng: "en",
    resources,
    supportedLngs: ["en"],
  });

export default i18n;
